/**
 * Piece Component - Renders X or O with image assets
 */

import React from 'react';
import xImg from '../../../img/x.png';
import oImg from '../../../img/0.png';

const PIECE_IMAGES = {
  X: xImg,
  O: oImg,
};

function Piece({
  type,
  isDraggable = false,
  isSelected = false,
  isDragging = false,
  onDragStart,
}) {
  const handlePointerDown = (e) => {
    if (isDraggable && onDragStart) {
      e.preventDefault();
      e.stopPropagation();
      onDragStart(e.clientX, e.clientY);
    }
  };

  const handleTouchStart = (e) => {
    if (isDraggable && onDragStart) {
      e.preventDefault();
      e.stopPropagation();
      if (e.touches && e.touches.length > 0) {
        const touch = e.touches[0];
        onDragStart(touch.clientX, touch.clientY);
      }
    }
  };

  const classNames = [
    'stt-piece',
    `stt-piece--${type.toLowerCase()}`,
    isDraggable && 'stt-piece--draggable',
    isSelected && 'stt-piece--selected',
    isDragging && 'stt-piece--dragging',
  ]
    .filter(Boolean)
    .join(' ');

  const src = PIECE_IMAGES[type];
  const alt = type === 'X' ? 'Cross' : 'Circle';

  return (
    <span
      className={classNames}
      onPointerDown={handlePointerDown}
      onTouchStart={handleTouchStart}
      role={isDraggable ? 'button' : undefined}
      tabIndex={isDraggable ? 0 : undefined}
      aria-label={`${type} piece${isDraggable ? ', drag to an adjacent empty cell' : ''}`}
      style={{ touchAction: isDraggable ? 'none' : undefined }}
    >
      <img className="stt-piece__img" src={src} alt={alt} draggable={false} />
    </span>
  );
}

export default Piece;
